<template>
    <form class="l_s_f" @submit.prevent="">
        <div class="form__row mb--15">
            <div class="flex-1 mr--5">
                <FormInput 
                    id="fullName"
                    v-model.trim="form.firstName"
                    type="text" 
                    size="md"
                    class="text--sm"
                    required 
                    no-margin-bottom
                    label-type="menu"
                    info-type="required"
                    placeholder="Enter first name"
                    label="First Name"
                />
            </div>

            <div class="flex-1">
                <FormInput 
                    id="lastName"
                    v-model.trim="form.lastName"
                    type="text" 
                    size="md"
                    class="text--sm"
                    no-margin-bottom
                    required 
                    label-type="menu"
                    info-type="required"
                    placeholder="Enter last name"
                    label="Last Name"
                />
            </div>
        </div>

        <FormInput 
            id="email"
            v-model.trim="form.email"
            type="email" 
            size="md"
            required 
            class="text--sm"
            label-type="menu"
            info-type="required"
            placeholder="Enter email address"
            label="Email"
        />

        <div class="mb--15">
            <FormLabel title="Issue type" info-type="required" />
            <CustomDropdown 
                id="issueDropdown" 
                v-model="form.issue" 
                :options="issues"
                size="md"
                index-label="name"
                :searchable="false"
                btn-classes="text--capitalize text--normal" 
                list-item-class="text--capitalize" 
                list-type="issues" 
                @select="v => form.issue = v" 
            />
        </div>

        <FormTextArea
            id="message"
            v-model.trim="form.message"
            type="text" 
            size="lg"
            class="text--sm"
            label-type="menu"
            info-type="required"
            required 
            placeholder="Enter your message"
            label="Your Message"
        />

        <p v-if="loadingState === 'failed'" class="form__err-msg mt--10 mb--10">
            {{ errMsg }}
        </p>

        <div v-if="loadingState === 'success'" class="form-text text--xs">
            <IconSvg name="" />
            <span>Message sent</span>
        </div>

        <div class="w-100 mt--20">
            <BaseButton 
                :loading="loadingState === 'loading'" 
                :disabled="btnDisabled" 
                full-width 
                size="md"
                class="text--sm"
                label="Send" 
                type="submit" 
                @submit="handleContinue"
            />
        </div>
    </form>
</template>

<script>
import { FormTextArea, BaseButton, FormInput, IconSvg, FormLabel, CustomDropdown } from "../../ui/index";
import { validateEmail } from "@/utils/helpers";
import api from "@/api/url";

export default {
    name: "SupportForm",


    components: {
        BaseButton,
        FormInput,
        FormTextArea,
        IconSvg,
        FormLabel, 
        CustomDropdown, 
    },

    props: {
        issueType: { type: String, default: "" },
    },

    emits: ["on-complete"],

    data() {
        return {
            isEmailInvalid: false,
            form: {
                firstName: "",
                lastName: "",
                email: "",
                issue: null,
                message: "",
            },
            loadingState: "",
            errMsg: "",
            errors: {},
            err: false,
            issues: [
                { id: "account", name: "Account" },
                { id: "payments_billings", name: "Payments & Billings" },
                { id: "signup", name: "Unable to sign up" },
                { id: "inquiries", name: "Inquiries"},
                { id: "pricing_plans", name: "Pricing plans" },
                { id: "other", name: "Other" },
            ],
        };
    },

    computed: {
        btnDisabled() {
            if (
                !this.form.email || 
                !this.form.firstName || 
                !this.form.message || 
                !this.form.issue || 
                !this.form.lastName
            ) {
                return true;
            }

            return false;
        },
    },

    watch: {
        issueType(newVal) {
            if (newVal) {
                this.form.issue = this.issues.find(x => x.id === newVal) || null;
            }
        },
    },

    methods: {
        validateEmail,

        checkEmail(event) {            
            this.errors.email = false;

            const val = event?.target?.value;
            const isValid = this.validateEmail(val);
            
            if (!isValid) {
                this.errors.email = true;
                return;
            }
            // this.form.email.msg = "Invalid email address";
        },

        async handleContinue() {      
            try {
                this.errMsg = "";
                this.loadingState = "loading";
                
                await api.app.sendSupportEmail({
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    email: this.form.email,
                    message: this.form.message, 
                    issue: this.form.issue.id, 
                });
                
                this.loadingState = "success";
                this.$toast.success("Form submitted!");

                this.form = {
                    firstName: "",
                    lastName: "",
                    email: "",
                    message: "",
                    issue: null,
                };
                this.$emit("on-complete");
            } catch (error) {
                this.loadingState = "failed";         
                const errMsg = error?.response?.data?.message || error.message;
                this.errMsg = errMsg;
            }
        },
    },
};
</script>